import { mapValues } from 'es-toolkit';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IndexMap {
  readonly [pdfId: number]: number;
}

interface DocumentToolsState {
  readonly indexMap?: IndexMap;
}

const initialState: DocumentToolsState = {};

const documentToolsSlice = createSlice({
  name: 'documentTools',
  initialState,
  reducers: {
    documentIndexChanged: (
      state,
      action: PayloadAction<{ readonly documentId: number; readonly newIndex: number }>,
    ) => {
      const { documentId, newIndex } = action.payload;

      if (newIndex >= 0 && newIndex < Object.keys(state.indexMap!).length) {
        const oldIndex = state.indexMap![documentId];
        const shift = newIndex > oldIndex ? -1 : 1;
        const range = shift * (oldIndex - newIndex);
        const newIndexMap = mapValues(state.indexMap!, (value) => {
          const difference = shift * (oldIndex - value);
          if (difference <= range && difference >= 0) {
            return value + shift;
          }
          return value;
        });

        newIndexMap[documentId] = newIndex;

        state.indexMap = newIndexMap;
      }
    },
    documentToolsShown: (state, action: PayloadAction<{ readonly indexMap: IndexMap }>) => {
      const { indexMap } = action.payload;
      state.indexMap = indexMap;
    },
  },
});

export const { documentIndexChanged, documentToolsShown } = documentToolsSlice.actions;
export const documentTools = documentToolsSlice.reducer;
